<template><div><h2>Actionsheet</h2>
<ul>
<li>[enhance] Better transition for mask</li>
</ul>
<h2>Alert</h2>
<ul>
<li>[enhance] Reset props data when used as plugin</li>
</ul>
<h2>Confirm</h2>
<ul>
<li>[fix] Fix plugin value and event watchers</li>
<li>[fix] Reset prop data when used as plugin</li>
</ul>
<h2>Datetime</h2>
<ul>
<li>[feature] Support prop:display-format #1086 @greedying</li>
</ul>
<h2>Loading</h2>
<ul>
<li>[enhance] Reset prop data when used as plugin</li>
<li>[enhance] Add fade transition</li>
</ul>
<h2>PopupPicker</h2>
<ul>
<li>[enhance] Fix mask render slowly in Safari. #1083 @sixiakun</li>
<li>[enhance] Enable transfer-dom by default</li>
</ul>
<h2>Popup</h2>
<ul>
<li>[fix] Fix wrong overflowScrolling when mask is disabled</li>
</ul>
<h2>XDialog</h2>
<ul>
<li>[enhance] Better mask transition and dialog transition</li>
<li>[enhance] Add transfer-dom demo</li>
<li>[enhance] Clean unused code</li>
</ul>
<h2>XTextarea</h2>
<ul>
<li>[feature] Add on-focus on-blur event #1082 @zeusLeeJh</li>
</ul>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.11_en-317.vue?4fd51266